

// Display modes for the full screen data presentation
export const ADMIN_FULL_SCREEN_DISPLAY_MODE_DIALOG = 'dialog';
export const ADMIN_FULL_SCREEN_DISPLAY_MODE_DRAWER = 'drawer';
